// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductsList-module__root___LTO-P","viewOptionTiles":"ProductsList-module__viewOptionTiles___ECbt6"};